export class CenterNationality {
  public id: number;
  public nameKz: string;
  public nameRu: string;
  public nameEn: string;
  public name: string;
  public code: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/nationality/center-nationality.ts